export const IS_LOADING = "[Reset Password] IS_LOADING";
export const SET_GOTO = "[Set GOto] SET_GOTO";

export const setgotochangepassword = (goto: boolean) => dispatch => {
  dispatch(gotopass(goto));
};
export const gotopass = (goto: boolean) => ({
  type: SET_GOTO,
  goto
});
export const setisLoading = (loading: boolean) => dispatch => {
  dispatch(isLoading(loading));
};
export const isLoading = (loading: boolean) => ({
  type: IS_LOADING,
  loading
});